module.exports = "<div class=\"app-limits-faq\">\n\t<div>\n\t\t<app-main-title title=\"Importante saber\"></app-main-title>\n\t\t<mat-card class='card'>\n\t\t\t<app-shared-accordion [accordionList]=\"list\"></app-shared-accordion>\n\t\t\t<div class=\"footer\" (click)=\"openHelpModal()\">\n\t\t\t\t<button>Central de Atendimento</button>\n\t\t\t</div>\n\t\t</mat-card>\n\t</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/limits/faq/faq.component.html
// module id = ../../../../../src/app/master/limits/faq/faq.component.html
// module chunks = main